export default __webpack_public_path__ + "static/media/AHRI-Logo.d4c29ae9.png";